import { create } from "zustand";

export type SidePanelType = "sources" | "channels";

interface SidePanelStore {
    isSidePanelOpen: boolean;
    type: SidePanelType | null;
    // True while the host renders the side panel as a modal (SidePanelAsModal is mounted), false when inline.
    isModal: boolean;
    setIsModal: (isModal: boolean) => void;
    openSidePanel: (type: SidePanelType) => void;
    toggleSidePanel: (type: SidePanelType) => void;
    closeSidePanel: () => void;
    isTypeOpen: (type: SidePanelType) => boolean;
}

export const useSidePanelStore = create<SidePanelStore>((set, get) => ({
    isSidePanelOpen: false,
    type: null,
    isModal: false,
    setIsModal: (isModal: boolean) => set({ isModal }),
    openSidePanel: (type: SidePanelType) => set({ isSidePanelOpen: true, type }),
    closeSidePanel: () => set({ isSidePanelOpen: false, type: null }),
    toggleSidePanel: (type: SidePanelType) => {
        // If the new type matches the current type, we close the panel
        // otherwise, we leave it open with the new type
        if (type === get().type) {
            get().closeSidePanel();
        } else {
            get().openSidePanel(type);
        }
    },
    isTypeOpen: (type: SidePanelType) => {
        const state = get();

        return state.isSidePanelOpen && state.type === type;
    }
}));
